import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { iniciarLlenado } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionInicioDeLlenadoView } from '../components/OperacionInicioDeLlenadoView'

export const OperacionInicioDeLlenado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionInicioDeLlenadoView
        silo={silo}
        aceptar={async ({ cereal, variedad, etiqueta, color }) => {
          try {
            await iniciarLlenado(silo, cereal, variedad, etiqueta, color)
            closeDialog()
            enqueueSnackbar('Inicio de llenado correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Inicio de llenado incorrecto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('INICIO_DE_LLENADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
